
import {EventVerteiler} from "@k/global/eventVerteiler";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";
import {LoginSuccessfulResult} from "@k/js/account/accountController";
import axios from "axios";
import {IResourceManager} from "@k/global/resourcemanager/IResourceManager";
import {ResourceInvalidationTriggers} from "@k/global/resourcemanager/resourceManager";

export function loginOnPageLoad(resourceManager:IResourceManager, username: string, password: string, language:string, land:string) {
    const $this = this;
    resourceManager.getOrRegisterResource("userLoggedIn").addState("initialized");
    axios.post("/konfigurator_php/sessiondata/login.php", {username, password, language, land})
        .then(()=>EventVerteiler.broadcast(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_SUCCESS, new LoginSuccessfulResult(data, onSuccess)))
        .catch(()=>{
            resourceManager.executeInvalidation("loginFailed");
            resourceManager.getOrRegisterResource("userLoggedIn").addState("failed")
                .invalidAfter(ResourceInvalidationTriggers.USERCHANGED);
        });
}
